// Supabase Client
import { supabase } from "@/utils/supabase/client";

let jwtToken: string | null = null;

export const getSupabaseJwt = async (): Promise<string> => {
  // If token exists, return it
  if (jwtToken) return jwtToken;

  // Fetch the current user's session
  const {
    data: { session },
    error,
  } = await supabase.auth.getSession();

  if (error || !session) {
    throw new Error("Unable to retrieve Supabase session");
  }

  // Cache the JWT token
  jwtToken = session.access_token;
  return jwtToken;
};

export const refreshSupabaseJwt = async (): Promise<string> => {
  const {
    data: { session },
    error,
  } = await supabase.auth.getSession();
  if (error || !session) {
    throw new Error("Unable to retrieve Supabase session");
  }

  // Cache the JWT token
  jwtToken = session.access_token;
  return jwtToken;
};
